module.exports = __webpack_public_path__ + "static/media/hot81.b102040e.jpeg";